import { useEffect, useState } from "react";
import { getProfile } from "../../../api/UserAPI";
import { useProfileStore } from "../../../stores/UserStore";
import { Group, Text } from "@mantine/core";
import AdminPanelCenter from "./center/AdminPanelCenter";
import AdminPanelRight from "./right/AdminPanelRight";
import { useNavigate, useParams } from "react-router-dom";
import AdminPanelLeft from "./left/AdminPanelLeft";
import { useLanguage } from "../../../stores/LanguageStore";

const AdminPanel = () => {
  const lang = useLanguage((s) => s.language);
  const me = useProfileStore((s) => s.profile);
  const { userId } = useParams();
  const [current, setCurrent] = useState(
    userId && userId !== "none" ? { id: parseInt(userId) } : me
  );
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [leftLoading, setLeftLoading] = useState(true);
  const [list, setList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (userId === "none") {
      navigate(`/settings/permissions/${me.id}`, { replace: true });
    } else {
      setCurrent({ id: parseInt(userId) });
    }
  }, [userId, me?.id, navigate]);

  useEffect(() => {
    setLoading(true);
    setProfile(null);
    if (current?.toDelete) {
      setList((prev) => prev.filter((x) => x.id !== current.toDelete.id));
    }
    getProfile(current?.id)
      .then((response) => {
        const url = location.pathname;
        const id = parseInt(url.split("/").pop());

        if (id === current?.id) {
          setProfile(response.data.user_profile);
        }
      })
      .finally(() => setLoading(false));
  }, [current]);

  return (
    <>
      <Group gap={"md"}>
        <Text size="xl" fw={600} mr={"auto"}>
          {lang.settings.permission_title}
        </Text>
      </Group>

      <Group align="start" wrap="nowrap" gap={0} h={"calc(100vh - 148px)"}>
        <AdminPanelLeft
          list={list}
          setList={setList}
          current={current}
          setCurrent={setCurrent}
          loading={leftLoading}
          setLoading={setLeftLoading}
        />
        <AdminPanelCenter
          loading={loading}
          profile={profile}
          setProfile={setProfile}
          me={me}
        />
        <AdminPanelRight
          changingProfile={loading}
          profile={profile}
          setProfile={setProfile}
        />
      </Group>
    </>
  );
};

export default AdminPanel;
